<template>
  <van-overlay :show="show" class="conn_voer">
    <div class="connection-empty">
      <p>您尚未注册参观本次展会，无权访问此页面</p>
      <p>完成注册即可继续浏览</p>
      <van-button class="btn" round color="#f85b0f" @click="gotoReg" >立即注册</van-button>
    </div>
  </van-overlay>
</template>

<script>
import { mapActions } from "vuex";
export default {
  name: "connection-empty",
  data() {
    return {
      show:true
    };
  },
  methods: {
    ...mapActions({ 
      LinkRegistry: "linkTo/LinkRegistry",
    }),
    //去注册
    gotoReg(){
      this.LinkRegistry(0);
    },
  },
};
</script>

<style lang="scss" scoped>
.conn_voer{
  background: rgba(0,0,0,0.75);
}
.connection-empty {
  padding-top: 3.7rem;
  text-align: center;
  font-size: 0.3rem;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0.98rem;
  p {
    line-height: 1;
    color: #fff;
    font-size: 0.3rem;
    &:first-child{
      margin-bottom: 0.33rem;
    }
  }
  .btn{
    display: block;
    margin: 2.35rem auto 0.3rem;
    height: 0.84rem;
    line-height: 0.84rem;
    width: 3rem;
    text-align: center;
    padding: 0;
    span{
      font-size: 0.3rem;
    }
  }
}
</style>